import React, { useState } from "react";

const InfoTab = ({ handleLayoutChange, selectedLayout,updateQRCodeTabData,qrCodeTabData }) => {
    const [title, setTitle] = useState(qrCodeTabData.title);
    const [callToActionText, setCallToActionText] = useState(qrCodeTabData.call_to_action_text);
    const [caption, setCaption] = useState(qrCodeTabData.caption);

    // Handlers Show Title Change
    const handleShowTitleChange = (e) => {
        const value = e.target.value;
        setTitle(value);
        updateQRCodeTabData("title", value); 
    };

    // Handlers Show Call To Action TextChange
    const handleShowCallToActionTextChange = (e) => {
        const value = e.target.value;
        setCallToActionText(value);
        updateQRCodeTabData("call_to_action_text", value); 
    };

    // Handlers Show Caption Change
    const handleShowCaptionChange = (e) => {
        const value = e.target.value;
        setCaption(value);
        updateQRCodeTabData("caption", value); 
    };
    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Info</span>
            <div className="side-baar-box-header">
                <div className="side-baar-box-header">
                    <div className="box-header-row input-fild">
                        <label>Title</label>
                        <input type="text" value={title} onChange={handleShowTitleChange} placeholder="" />
                    </div>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="side-baar-box-header">
                    <div className="box-header-row input-fild">
                        <label>Call To Action Text</label>
                        <input type="text" value={callToActionText} onChange={handleShowCallToActionTextChange} placeholder="" />
                    </div>
                </div>
            </div>

            <div className="side-baar-box-header">
                <div className="side-baar-box-header">
                    <div className="box-header-row input-fild">
                        <label>Caption</label>
                        <input type="text" value={caption} onChange={handleShowCaptionChange} placeholder="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoTab;